module.exports = __webpack_public_path__ + "img/bb1844a0-c0fb-4519-ad7d-a63b57be3f5a.cf47f98e.png";